// Centralized API and uploads URL helpers
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const API = `${API_BASE.replace(/\/$/, '')}/api`;
const UPLOADS = `${API_BASE.replace(/\/$/, '')}/uploads`;

export { API_BASE, API, UPLOADS };
